export function fillMissingDates(labels) {
  if (!labels || labels.length == 0) {
    return labels;
  }
  let last = labels[0].clone();
  let result = [last];
  for (let i = 1; i < labels.length; i++) {
    let currentShouldBe = last.clone().add(1, "days");
    while (isDateBefore(currentShouldBe, labels[i])) {
      result.push(currentShouldBe);
      currentShouldBe = currentShouldBe.clone().add(1, "days");
    }
    result.push(labels[i]);
    last = labels[i].clone();
  }
  return result;
}

function isDateBefore(currentShouldBe, label) {
  return (
    currentShouldBe.dayOfYear() < label.dayOfYear() ||
    currentShouldBe.year() < label.year()
  );
}
